
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/toaster";
import AppRoutes from './routes';
import { AuthProvider } from './contexts/auth/AuthContext';
import { AdminProvider } from './contexts/admin/AdminContext';
import ScrollToTop from './components/ScrollToTop';
import { useEventTracking } from '@/hooks/useEventTracking';
import './App.css';

// Analytics component that initializes tracking
const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEventTracking(); // This will initialize session tracking and auto page tracking
  return <>{children}</>;
};

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      retry: 1,
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AuthProvider>
            <AdminProvider>
              <AnalyticsProvider>
                <ScrollToTop />
                <AppRoutes />
                <Toaster />
              </AnalyticsProvider>
            </AdminProvider>
          </AuthProvider>
        </Router>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
